import { Box, Stack, Tooltip } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import { styled } from '@mui/material/styles';
import {
  cloneElement,
  useRef,
  Children,
  ReactElement,
  PropsWithChildren,
  FunctionComponent,
  useState,
} from 'react';
import { WsColors, WsDrawer } from 'wisestep-base';

const Bar = styled(Box)(() => ({
  zIndex: '1298',
  position: 'fixed',
  bottom: '1.5rem',
  textAlign: 'center',
  left: '50%',
  transform: 'translateX(-50%)',
  borderRadius: '0.5rem',
  background: WsColors.TheBlues900,
  padding: '0.5rem 0.75rem',
}));

interface CommBarComposition {
  Item: FunctionComponent<CommBarItemProps>;
}

interface CommBarItemProps {
  icon: FunctionComponent<{ size?: number }>;
  title: string;
}

const CommBarItem = () => <></>;

interface CommBarItemRef {
  close?: () => Promise<void>;
  open?: () => void;
}

const CommunicationBar: FunctionComponent & CommBarComposition = ({ children }) => {
  const openRef = useRef<CommBarItemRef>();
  const [open, setOpen] = useState(-1);

  return (
    <>
      {Children.map(children, (child, index) => {
        const item = child as ReactElement<PropsWithChildren<CommBarItemProps>>;
        if (item.props.title === 'Coming soon!') return null;
        const itemContent = Children.only(item.props.children);
        return (
          <WsDrawer
            open={open === index}
            onClose={async () => {
              await openRef?.current?.close?.();
              setOpen(-1);
            }}
            title={item.props.title}
          >
            {cloneElement(itemContent as ReactElement, {
              ...(open === index && { ref: openRef }),
            })}
          </WsDrawer>
        );
      })}
      <Box mt={16}>
        <Bar sx={{ boxShadow: 12 }}>
          <Stack direction="row" spacing={1.5}>
            {Children.map(children, (child, index) => {
              const item = child as ReactElement<PropsWithChildren<CommBarItemProps>>;
              const Icon = item.props.icon;
              return (
                <Tooltip key={item.props.title} title={item.props.title} placement="top">
                  <IconButton
                    size="medium"
                    sx={{ color: open === index ? WsColors.TheBlues500 : 'common.white' }}
                    onClick={async () => {
                      if (item.props.title === 'Coming soon!') return;
                      if (open !== -1) {
                        await openRef?.current?.close?.();
                        setOpen(open === index ? -1 : index);
                      } else {
                        setOpen(index);
                      }
                    }}
                  >
                    <Icon size={24} />
                  </IconButton>
                </Tooltip>
              );
            })}
          </Stack>
        </Bar>
      </Box>
    </>
  );
};

CommunicationBar.Item = CommBarItem;

export default CommunicationBar;
